import { Card, CardBody, Col, Container, Row } from "reactstrap";
import ProductGrid from "./ProductGrid";


const CLothAssign = () => {
  return (
    <div className='page-body'>
        <Container fluid>
            <Row>
                <Col sm="12">
                <Card>
                    <CardBody>
                        <div className="container mt-4">
                            <div className="row gy-4">
                                {/* Product Grid Column */}
                                <ProductGrid />
                            </div>
                        </div>
                    </CardBody>
                </Card>
                </Col>
            </Row>
        </Container>
    </div>
  )
}

export default CLothAssign